import { forwardRef, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { DependencyTreeCanActivate } from 'app/core/guards/dependency-tree.guard';
import { GetDefinitionsGuard } from 'app/core/store/definitions/definitions.resolve';
import { AuthorizationGuard } from 'app/core/store/session/authorization/authorization.resolve';
import { Observable, of } from 'rxjs';
import * as fromRoot from '..';
import * as actions from './relocation-detail.actions';
import { EditRelocationDetail } from './relocation-detail.interface';
import { logger } from 'app/core/util/logger';
import { filter, first, map, switchMap } from 'rxjs/operators';

/**
 * Guard to async load an order before following a route
 */
@Injectable({ providedIn: 'root' })
export class GetRelocationGuard implements CanActivate, DependencyTreeCanActivate {
  private store: Store<fromRoot.RootState>;

  constructor(@Inject(forwardRef(() => Store)) store) {
    this.store = store;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    logger.debug(`In GetRelocationGuard`);

    return this.store.pipe(
      filter((root: fromRoot.RootState) => root.session.userContext.contextLoaded),
      first(),
      switchMap(root => {
        if (root.session.userContext.canRelocate) {
          this.store.dispatch(
            new actions.RelocationDetailOpenAction({
              salesOrderNumber: route.paramMap.get('salesOrderNumber') !== 'null' ? route.paramMap.get('salesOrderNumber') : null,
              etmOrderNumber: route.paramMap.get('etmOrderNumber'),
            })
          );
          return this.store.select('editRelocationDetail').pipe(
            filter((editRelocationDetail: EditRelocationDetail) => !editRelocationDetail.mode.loading),
            first(),
            map((editRelocationDetail: EditRelocationDetail) => editRelocationDetail.mode.loadSuccess)
          );
        } else {
          return of(false);
        }
      })
    );
  }

  getDependencies(): any {
    return [AuthorizationGuard, GetDefinitionsGuard];
  }

  getDependencyRouteData(): any {
    return {
      authorization: 'canRelocate',
    };
  }
}
